import { combineReducers } from '@reduxjs/toolkit';
import { authSlice } from './auth';
import { searchSlice } from './search';
import { accountSlice } from './account';
import { emailConfigSlice } from './emailConfig';
import { loginHistorySlice } from './loginHistory';
import { logSlice } from './log';
import { apiRoleMappingSlice } from './apiRoleMapping';
import { menuItemSlice } from './menuItem';
import { projectSlice } from './project';
import { personalTaskSlice } from './personalTask';

const rootReducer = combineReducers({
    auth: authSlice.reducer,
    search: searchSlice.reducer,
    account: accountSlice.reducer,
    emailConfig: emailConfigSlice.reducer,
    loginHistory: loginHistorySlice.reducer,
    log: logSlice.reducer,
    apiRoleMapping: apiRoleMappingSlice.reducer,
    menuItem: menuItemSlice.reducer,
    project: projectSlice.reducer,
    personalTask: personalTaskSlice.reducer,
});

export default rootReducer;
